module.exports = __webpack_public_path__ + "img/wechat-mp-code-generator.8b6ac856.jpg";